
import UIfx from 'uifx';
import alertSound from '../assets/alert.mp3';
const alert = new UIfx(alertSound);

export const playSound = () => alert.play();